import { render, staticRenderFns } from "./CompradorModal.vue?vue&type=template&id=22c2def7&"
import script from "./CompradorModal.vue?vue&type=script&lang=js&"
export * from "./CompradorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports